import { PdlLoans } from '@/features';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/pdl/loans/')({
  component: RouteComponent,
  staticData: {
    icon: 'HandCoins',
    title: 'Loans',
  },
});

function RouteComponent() {
  return <PdlLoans />;
}
